import React from "react";
import SaveIcon from '@mui/icons-material/Save';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import Sidebar from "./sidebar/Sidebar.jsx";
import DragButton from "./commons/DragButton.jsx";
import Modal from "./commons/Modal.jsx";
import Stammdaten from "./Stammdaten.jsx";
import SaveModal from "./SaveModal.jsx";
import uiActions from "../uiActions.js";
import InterieurDragBox from "../../object3d/InterieurDragBox";
import Fach from "../../object3d/Fach";
import OcAr from "oc-threejs/ar/oc-ar";
import SidebarMenuItem from "./commons/SidebarMenuItem";
import DeviceDetection from "oc-commons/DeviceDetection";
import Helper from "../../model/Helper";

// Wird bald für Facebook 3D Share benötigt
/* import GLTFExporter from "oc-threejs/patched/GLTFExporter.oc.js" */

export default class UI extends React.Component {
    constructor(props) {
        super(props);
        APP.uiHandler.ui = this;
        this.state = {
            model: APP.model,
            sidebar: {
                type: "korpus",
            },
            modal: {},
            input_modal: {},
            topClasses: [],
            showAdditionalIcons: false,
        };
        this.toggleAdditionalIcons = this.toggleAdditionalIcons.bind(this);
        this.resetCam = this.resetCam.bind(this);
        // this.arRef = React.createRef();
        /* this.exportGLB = this.exportGLB.bind(this); */
        this.maybeHideSidebar();
        this.arRef = React.createRef();
        this.updateUiColors();
    }

    updateUiColors() {
        const baseColor = APP.settings.base_color;
        const secondaryColor = APP.settings.secondary_color;
        if (baseColor && secondaryColor) {
            document.documentElement.style.setProperty("--color-base", baseColor);
            document.documentElement.style.setProperty("--color-primary", secondaryColor);
        }
    }

    // componentDidMount() {
    //     this.prepareAR();
    // }

    sockelEnabled() {
        const currentSchrankModellName = APP.arrangement.schraenke[APP.arrangement.currentSchrankIndex].modell.Name
        const werte = APP.metadata.Modellwerte[currentSchrankModellName];
        return werte ? werte.sockel?.Wert == 'ja' : false;
    }

    maybeHideSidebar() {
        if (!DeviceDetection.isSmartphoneDisplay) {
            return;
        }
        STAGE.on("drag3dBegin", () => {
            $("#scroll-sidebar").hide();
        });
        STAGE.on("drag3dEnd", () => {
            $("#scroll-sidebar").show();
            this.showSidebar(null);
        });
    }

    updateFromArrangement() {
        //console.log("ARRANGEMENT UPDATE")
        this.setState(this.state);
    }

    // Das ist sicher nicht der Weisheit letzter Schluss...
    asset(path) {
        return SETTINGS.wkfgContentBaseUrl + path;
    }

    draggable(element, type) {
        const product = APP.productList.filter((p) => p.type == type)[0];
        APP.interactionHandler.draggable(element).setDragObject3D((handle) => APP.model.createDragObject(product));
    }

    removeTopClass(c) {
        this.setState({
            topClasses: this.state.topClasses.filter((cl) => cl != c),
        });
    }

    addTopClass(c) {
        this.state.topClasses.push(c);
        this.setState({
            topClasses: this.state.topClasses,
        });
    }

    showSidebar(type, data) {
        this.setState({
            sidebar: {
                type: type,
                ...data,
            },
        });
    }
    
    showModal(options) {
        this.addTopClass("visible-modal");
        this.setState({ modal: options });
    }

    hideModal() {
        this.removeTopClass("visible-modal");
        this.setState({ modal: {} });
    }

    hideSidebar() {
        this.setState({
            sidebar: {
                type: "closed",
                show: false,
            },
        });
        /* this.addTopClass("hidden-sidebar");
        this.removeTopClass("hidden-footer");
        APP.model.showDoorsClosed(true);
        APP.model.selectElement(-1);
        this.toggleAdditionalIcons(false); */
    }

    onInfoClick() {
        APP.uiHandler.dialog({
            title: I18N("Coming soon"),
            text: I18N("In Kürze werden Sie hier Ihre Planung in den sozialen Medien teilen können."),
            buttons: [
                {
                    style: "primary",
                    label: I18N("In Ordnung!"),
                },
            ],
        });
    }

    onFBShare() {
        /* const toDo = (URL) => {
            const window = this.props.handler.window;
            const myURL = encodeURIComponent(window.location.href);
            const leftX = window.outerWidth / 2 - 200;
            const windowFeatures = "menubar=no,resizable=yes,toolbar=no,scollbars=yes,chrome=yes,centerscreen=yes,width=600,height=800,left=" + leftX;
            setTimeout(() => window.open("https://www.facebook.com/sharer/sharer.php?u=" + myURL + "&amp;src=sdkpreparse",
                "ObjectCode_FB", windowFeatures), 1000);
        }
        this.exportGLB(toDo); */

        APP.uiHandler.dialog({
            title: I18N("Coming soon"),
            text: I18N("In Kürze werden Sie hier Ihre Planung in den sozialen Medien teilen können."),
            buttons: [
                {
                    style: "primary",
                    label: I18N("In Ordnung!"),
                },
            ],
        });
    }

    onSave() {
        APP.uiHandler.dialog({
            title: I18N("Speichern"),
            child: <SaveModal />,
            buttons: [
                {
                    style: "primary",
                    label: I18N("Schließen")
                },
            ],
        });
    }

    reset() {
        if (APP.resetToConfiguration) {
            APP.arrangement.fromJSON(APP.resetToConfiguration.Json);
        } else {
            APP.arrangement.fromJSON(APP.configuration.Json);
        }
        APP.arrangement.compile();
        APP.model.setDirty();
        this.toggleAdditionalIcons(false);
    }

    undo() {
        APP.undoHandler.undo();
        APP.model.setDirty();
        this.toggleAdditionalIcons(false);
    }

    redo() {
        APP.undoHandler.redo();
        APP.model.setDirty();
        this.toggleAdditionalIcons(false);
    }

    resetCam() {
        STAGE.resetOrbitControl();
        APP.model.setFullCam(APP.model.cameraExtraZoom);
        this.toggleAdditionalIcons(false);
    }

    toggleAdditionalIcons(toggle) {
        if (toggle === true || toggle === false) {
            this.setState({ showAdditionalIcons: toggle });
        } else {
            APP.on("changedConfiguration", () => this.updateUI());
            this.setState({ showAdditionalIcons: !this.state.showAdditionalIcons });
        }
    }

    updateHeight() {
        this.setState({ height: document.documentElement.clientHeight });
    }

    UNSAFE_componentWillMount() {
        this.updateHeight();
    }

    componentDidMount() {
        this.prepareOcAr();

        window.addEventListener(
            "resize",
            _.debounce(() => {
                this.updateHeight();
            }, 300)
        );
    }

    prepareOcAr() {
        const ocar = this.arRef.current;
        if (ocar) {
            ocar.save = (arcallback, failCB) => {
                this.blur = STAGE.freezeRendererAndBlur();
                uiActions._saveAction(
                    (link, data) => {
                        this.blur.hideDialog();
                        this.updateFromArrangement();
                        arcallback(APP.configuration.Code);
                    },
                    (err) => {
                        failCB();
                        alert(err);
                        APP.uiHandler.dialog({
                            title: I18N("saveFailed"), //'Speichern ist fehlgeschlagen!',
                            text: I18N("saveFailedText"), //'Wir konnten Ihren Schrank nicht speichern.',
                            buttons: [{ style: "primary", label: I18N("OK") }],
                        });
                    }
                );
            };
            ocar.augmentedReality = {
                object3d: APP.arrangement.object3d.children[0],
                instancesToBeHidden: [InterieurDragBox, Fach],
                onSuccess: () => {},
                before: (o3) => {
                    o3.scale.multiplyScalar(0.01);
                },
                after: (o3) => {},
                projectName: "ocschrank",
            };
            ocar.arTitle = "ObjectCode Schrankkonfigurator";
        }
    }

    componentDidUpdate() {
        window.addEventListener(
            "resize",
            _.debounce(() => {
                this.updateHeight();
            }, 300)
        );
        // this.arRef.current.configuration=APP.configuration.Code;
    }

    render() {

        const haendler = APP.haendler;
        const isHaendler = APP.settings.haendler != null;
        let logo = 'Settings/' + APP.settings.logo;
        let logolink = APP.settings.logo_url;

        if(haendler && haendler.Logo && APP.settings.use_haendlerlogo) {
            logo = haendler.Logo;
            logolink = "";
        }

        return (
            <div id="cfg-container" className={this.state.topClasses.join(" ")} style={{ height: this.state.height }}>
                <div className="main-div">
                    {/* Header */}
                    <header id="header">
                        <div className="head-child left no-mobile">
                            <div className="logo">
                                <a href={logolink} className="logo-mid">
                                    <img className="logoImg" src={SETTINGS.wkfgContentBaseUrl + logo} />
                                </a>
                                <a className="logo-mid created-by-oc" href="https://www.objectcode.de" target="_blank">
                                    Created by <span className="oc-logo"></span>
                                </a>
                            </div>
                        </div>
                        {this.state.info && (
                            <div className="head-child middle">
                                <div className="title">{this.state.info}</div>
                            </div>
                        )}
                        <div className="head-child right">
                            <button
                                className={"pointer icon ruler"}
                                onClick={() => APP.model.showMaßlinien(!APP.arrangement.maße)}
                            ></button>
                            <button className="pointer icon reload" onClick={() => this.reset()} title={I18N("Alles zurücksetzen")} />
                            <button className="pointer icon arrow-left" onClick={() => this.undo()} title={I18N("Widerrufen")} />
                            <button className="pointer icon arrow-right" onClick={() => this.redo()} title={I18N("Wiederholen")} />
                            <button className="pointer icon reset-camera" onClick={() => this.resetCam()} title={I18N("Kamera zentrieren")} />
                            <button
                                className={"pointer icon door-button " + (APP.arrangement.doorsClosed ? "door-closed" : "door-open")}
                                onClick={() => APP.model.showDoorsClosed(!APP.arrangement.doorsClosed)}
                            ></button>                       
                        </div>
                    </header>
                    {/* End: Header */}
                    {/* ================================== */}
                    {/* Main */}
                    <Sidebar state={this.state.sidebar} model={this.state.model} />
                    <main role="main">
                        {/* Main: Content */}
                        <div style={{ height: "100%" }} className="wardrobe-wrapper threejsRenderer dragdrop">
                            <div className="mobile-price-wrapper">
                                <div className="price-wrapper">
                                    <div className="price-inner">
                                        <div className="price">{Helper.formatMoney(APP.arrangement.preis?.gesamtPreis)}</div>
                                        {APP.settings.userLoggedIn && APP.arrangement.preis?.rabatt > 0 && (
                                            <div className="rabatt">
                                                - {Helper.formatMoney(APP.arrangement.preis?.rabatt)} [{I18N("Haendlerrabatt")}] ={" "}
                                                {Helper.formatMoney(APP.arrangement.preis?.gesamtPreis - APP.arrangement.preis?.rabatt)}
                                            </div>
                                        )}
                                        <div className="shipment">{I18N("Lieferung DE")}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="left-corner-wrapper">
                                <div className="price-wrapper">
                                    {APP.settings.ar && (
                                        <oc-ar ref={this.arRef} configuration={APP.configuration.Code}>
                                            <div slot="icon" className="oc-ar">
                                                <button className="icon ar-google"></button>
                                                <span>{I18N("ViewInAr")}</span>
                                            </div>
                                        </oc-ar>
                                    )}
                                </div>
                            </div>
                        </div>
                        {/* End: Main: Content */}
                    </main>
                    <Modal
                        title={this.state.modal.title}
                        text={this.state.modal.text}
                        child={this.state.modal.child}
                        thumbnail={this.state.modal.thumbnail}
                        buttons={this.state.modal.buttons}
                        onClose={() => {
                            this.hideModal();
                            if (this.state.modal.onClose) this.state.modal.onClose();
                        }}
                    />

                    {/* End: Main */}
                </div>
                {/* ================================== */}
                {/* Footer */}
                <footer className="footer">
                    <div className="inner-footer">
                        <div className="group left no-tablet-small"></div>

                        <div className="group center">
                            <SidebarMenuItem name="korpus" label={I18N("Korpus")} image={this.asset("img/Korpus_01.svg")} doorsClosed={true} />
                            <SidebarMenuItem name="einbauten" label={I18N("Ausstattung")} image={this.asset("img/Ausstattung_01.svg")} doorsClosed={false} />
                            <SidebarMenuItem name="tueren" label={I18N("Türen")} image={this.asset("img/Tueren_01.svg")} doorsClosed={true} />
                            <SidebarMenuItem name="dekore" label={I18N("Farben")} image={this.asset("img/Farben_01.svg")} doorsClosed={true} />
                            <SidebarMenuItem name="griffe" label={I18N("Griffe")} image={this.asset("img/Griffe_01.svg")} doorsClosed={true} />
                        </div>
                        <div className="group right noshrink">
                            <div className="price-wrapper no-mobile no-tablet-small">
                                <div className="price-inner">
                                    <div className="price">{Helper.formatMoney(APP.arrangement.preis?.gesamtPreis)}</div>
                                    {APP.settings.userLoggedIn && APP.arrangement.preis?.rabatt > 0 && (
                                        <div className="rabatt">
                                            - {Helper.formatMoney(APP.arrangement.preis?.rabatt)} [{I18N("Haendlerrabatt")}] ={" "}
                                            {Helper.formatMoney(APP.arrangement.preis?.gesamtPreis - APP.arrangement.preis?.rabatt)}
                                        </div>
                                    )}

                                    <div className="shipment">{I18N("Lieferung DE")}</div>
                                </div>
                            </div>
                            {/*
                            <SidebarMenuItem
                                className="footer-primary w-100"
                                name="stammdaten"
                                label={I18N("Warenkorb")}
                                image={this.asset("img/shopping-cart-solid.svg")}
                                doorsClosed={true}
                            />
                            */}
                            <div
                                className="image-text stop-select footer-primary active"
                                style={{ width: "100%" }}
                                onClick={() => this.showModal({
                                        child: <Stammdaten />,
                                        buttons: [
                                            {
                                                label: I18N("Schliessen"),
                                                style: "primary",
                                                onClick: () => this.hideModal()
                                            }
                                        ]
                                    }
                                )}
                            >
                                <div className="image no-pointer">
                                    <ShoppingCartIcon sx={{color: "#0e1117"}} className="footer-img" />
                                </div>
                                {isHaendler ? I18N("HaendlerAnfragen") : I18N("Anfragen")}
                            </div>
                            <div
                                className="image-text stop-select footer-primary active"
                                style={{ width: "100%" }}
                                onClick={() => this.onSave()}
                            >
                                <div className="image no-pointer">
                                    <SaveIcon sx={{color: "#0e1117"}} className="footer-img" />
                                </div>
                                {I18N("Speichern")}
                            </div>
                        </div>
                    </div>
                </footer>
                {/* END: Footer */}
            </div>
        );
    }
}
